module.exports = __webpack_public_path__ + "media/images/landing/people_full_old_origin-bb68f8a4dc2ac9a5f49d4cc56fc422b0.png";